import './interaction-record-popin.component.ajscss';

import { RecordDeprecatedService } from '@agent/core/phone/record-deprecated.service';
import { IContactEntry } from '@commons/models/contact-entry';
import { Audio, Playlist } from '@commons/toolbox/media-player/models/audio';
import { IHistoryDeprecatedService } from '@history/core/history-deprecated.service';
import { IComponentController, IComponentOptions, ILogService, isDefined } from 'angular';

import { DisplayDeprecatedComponent, MomentService } from '@contact/upgrade';

import templateUrl from './interaction-record-popin.component.ajs.html';

export interface Interaction extends IContactEntry {
  hasRecord: boolean;
  record: any;
  sort: number;
}

class InteractionRecordPopinCtrl extends DisplayDeprecatedComponent implements IComponentController {
  close: Function;
  dismiss: Function;
  resolve: Function;

  interaction: Interaction;

  playlist: Playlist; // first empty one
  currentAudio: Audio;
  mp3Url: string;

  urlRespUrl: string;

  constructor(
    private readonly $log: ILogService,
    private readonly historyDeprecatedService: IHistoryDeprecatedService,
    private readonly recordDeprecatedService: RecordDeprecatedService,
    private readonly timeUtil: MomentService
  ) {
    super();
  }

  $onInit(): void {
    // TODO: Afficher "L'enregistrement n'est pas disponible car il a été exclu par la stratégie mise en place côté service d'enregistrement" si l'enregistrement est "OUT_STRATEGY"

    this.recordDeprecatedService.getRecordDownloadUrl().subscribe(url => (this.urlRespUrl = url));

    // read the modal parameter, type of ModalParamContactHisto
    let param = this.resolve();
    if (isDefined(param)) {
      this.interaction = param.interaction;
    } else {
      this.$log.error('[HistoryImportCsvCtrl] missing compulsory modal parameter');
    }

    this.historyDeprecatedService.execSearchRecordFromInteractionRequest(encodeURI(this.interaction.technicalId)).subscribe(
      next => {
        this.interaction.record = next;
        this.playlist = [this.getCurrentAudioFile()];
        this.mp3Url = this.getRecordURI(this.interaction);
      },
      error => {
        this.$log.error('[InteractionRecordCtrl] ' + error);
      }
    );
  }

  getRecordURI(row: Interaction) {
    if (row === undefined) {
      return '';
    }
    return this.urlRespUrl + row.technicalId;
  }

  playRecord(): void {
    this.currentAudio = this.getCurrentAudioFile();
  }

  onChangeAudio({ audio }): void {
    this.currentAudio = audio;
  }

  // record functions
  getCurrentAudioFile(): Audio {
    let _caf: Audio = {
      title: '[' + this.interaction.contactUri + '] ',
      url: this.urlRespUrl + encodeURIComponent(this.interaction.technicalId),
    };
    return _caf;
  }

  readableDateTimeNoSep(dateToConvert: Date) {
    return this.timeUtil.readableDateTimeNoSep(dateToConvert);
  }
}

export class InteractionRecordPopin implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    // from ui-bootstrap modal
    close: '&',
    dismiss: '&',
    resolve: '&',
  };
  controller = ['$log', 'historyDeprecatedService', 'momentService', 'recordDeprecatedService', InteractionRecordPopinCtrl];
}

export default 'historyInteractionRecordPopIn';
